import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import TopHeader from '../components/TopHeader';
import ChangePWForm from '../components/forms/ChangePWForm';
import BackButton from '../components/BackButton';
import { useTheme } from '../contexts/ThemeContext';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
`;

const ChangePasswordView = () => {
  const { theme, themeName } = useTheme();
  const history = useHistory();
  const isHelexia = themeName === 'helexia';
  const isGalp = themeName === 'galp';

  if (isGalp) {
    // The Galp change-password screen (header + fields + fixed footer) is
    // rendered entirely by ChangePWForm's own isGalp branch.
    return <ChangePWForm />;
  }

  if (isHelexia) {
    return (
      <div style={{
        width: '100%',
        height: '100dvh',
        background: 'white',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
      }}
      >
        <TopHeader
          title="password_title"
          userLogo
          showBackButton
          onBack={() => history.push('/home-no-vm')}
          backButtonColor={theme.titleColor}
          showShadow
        />
        <div style={{
          flex: 1,
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          padding: '20px 12px 66px',
        }}
        >
          <ChangePWForm />
        </div>
      </div>
    );
  }

  return (
    <Root>
      <div style={{ flex: 1 }}>
        <TopHeader title="change_password" userLogo />
        <ChangePWForm />
      </div>
      <BackButton screen="home" />
    </Root>
  );
};

export default ChangePasswordView;
